package org.catharsis.spendtel.feature.presentation.legal

import androidx.compose.runtime.Composable
import androidx.navigation.NavHostController
import org.catharsis.spendtel.feature.legal.LegalDocumentType
import org.catharsis.spendtel.feature.presentation.web.WebLegalDocumentScreen

@Composable
actual fun LegalDocumentScreen(
    navHostController: NavHostController,
    documentType: LegalDocumentType,
) {
    WebLegalDocumentScreen(
        navHostController = navHostController,
        documentType = documentType,
    )
}
